import React, { useState } from "react";
import { Link } from "react-router-dom";

const ModernNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="modern-navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <img src="/assets/logo.png" alt="Optimus" className="brand-logo" />
          <span className="brand-text">Optimus</span>
        </Link>

        <div className="navbar-center">
          <div className="navbar-nav">
            <Link to="/struts-ai" className="nav-link">
              <span className="nav-icon">🤖</span>
              Struts AI
            </Link>
            <Link to="/kodi-africa" className="nav-link">
              <span className="nav-icon">📊</span>
              Kodi Africa
            </Link>
            <Link to="/contact" className="nav-link">
              <span className="nav-icon">📞</span>
              Contact
            </Link>
          </div>
        </div>

        <div className="navbar-actions">
          <Link to="/login" className="btn-outline">
            Login
          </Link>
        </div>

        <button
          className={`mobile-menu-toggle ${isMenuOpen ? "active" : ""}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default ModernNavbar;
